<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Complaint Administration
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="showList" class="flex flex-col">
      <br />
      <form [formGroup]="form">
        <div class="flex flex-row rounded-lg w-full">
          <div>
            <mat-form-field class="container">
              <mat-label>Search Text</mat-label>
              <input matInput formControlName="searchText" placeholder="Enter search text here">
              <mat-error *ngIf="form.get('searchText').invalid">
                Search text must be at least 3 characters
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <button mat-raised-button (click)="getSearchComplaintData()" class="m-8" style="background: #7ABDF3;">
              <mat-icon>search</mat-icon>
              Search
            </button>
          </div>

        </div>
      </form>
    </div>

    <div *ngIf="showList" class="flex flex-col w-full">

      <div class="flex flex-col w-full" style="overflow-x:auto;">
        <div class="flex flex-row w-full">
          <div class="flex w-3/4">
            Results: ({{listCount}})
          </div>
          <div class="flex flex-row w-1/2 rounded-lg justify-end">
            <input (keyup)="filterTable($event)" placeholder="Search" [value]="filter" />
          </div>
        </div>
        <div class="flex flex-row w-full">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort" class="w-full">

            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let complaint"><a (click)="rowClick(complaint)">{{complaint.complaintId}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="complaintStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.complaintStatus}}
              </td>
            </ng-container>
            <ng-container matColumnDef="actionable">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Actionable</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.actionable" style="color: green;">Yes</span>
                <span *ngIf="!complaint.actionable" style="color: red;">No</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="reasonNonActionable">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason Non-Actionable</th>
              <td mat-cell *matCellDef="let complaint">
                {{!complaint.actionable? complaint.reasonNonActionable: ''}}
              </td>
            </ng-container>
            <ng-container matColumnDef="businessName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.businessName}}</td>
            </ng-container>
            <ng-container matColumnDef="businessActive">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Status</th>
              <td mat-cell *matCellDef="let complaint">
                <span *ngIf="complaint.businessActive" style="color: green;">Active</span>
                <span *ngIf="!complaint.businessActive" style="color: red;">Inactive</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

          </table>
        </div>

        <mat-paginator [pageSizeOptions]="[20, 100]" #TablePaginator="matPaginator"
          showFirstLastButtons></mat-paginator>
      </div>

    </div>

    <div *ngIf="!showList" class="flex flex-col items-center w-full">
      <div class="flex flex-col rounded-lg w-11/12" style="padding: 20px;">
        <span>
          Administrative Edit Complaint
        </span>
        <hr style="border: 1px solid gray;">
        <br />
        <form [formGroup]="complaintForm">
          <div class="flex flex-col rounded-lg w-full">
            <mat-form-field class="container">
              <mat-label>Complaint ID</mat-label>
              <input matInput formControlName="complaintId" placeholder="Enter search text here">
            </mat-form-field>
            <mat-form-field class="container">
              <mat-label>Date</mat-label>
              <input matInput formControlName="complaintDate" placeholder="Enter search text here">
            </mat-form-field>

            <mat-form-field class="container">
              <mat-label>Text</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="complaintComments"></textarea>
            </mat-form-field>

            <mat-form-field class="container">
              <mat-label>Status</mat-label>
              <mat-select formControlName="complaintStatusId">
                <mat-option *ngFor="let list of statusList" [value]="list.value">
                  {{list.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="container">
              <mat-label>Is Complaint Actionable?</mat-label>
              <mat-select formControlName="actionable" (selectionChange)="updateActionable($event.value)">
                <mat-option value="true">Yes</mat-option>
                <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>

            <div class="flex flex-row w-full">{{actionableComplaint?'Nature of Complaint':'Reason'}}</div>

            <div class="flex flex-row w-full" *ngIf="actionableComplaint && !showList">
              <div class="flex flex-col w-3/4">
                <mat-checkbox *ngFor="let violation of selectStatusList" (change)="check(violation, $event)"
                  [checked]="isViolationChecked(violation)">
                  <span *ngIf="violation.group.name == 'Active'">{{violation.text}}</span>
                </mat-checkbox>
              </div>
              <div class="flex flex-row w-1/2 rounded-lg justify-end">
                <mat-form-field class="rounded-lg w-full">
                  <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="10" formControlName="warning"
                    style="color: red;"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-column w-full" *ngIf="!actionableComplaint">
              <!-- <span><strong>Warning: </strong>Saving this complaint will remove the following (no longer in use) Nature of Complaint Settings:</span> -->
              <mat-form-field class="container">
                <mat-select formControlName="reason">
                  <mat-option *ngFor="let list of nonActionableList" [value]="list.value">
                    {{list.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex flex-row" style="align-items: flex-start;">
              <div style="padding-right: 20px;">
                <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
                  Save
                </button>
              </div>
              <div style="padding-right: 20px;">
                <button mat-raised-button (click)="cancel()" class="m-8 container">
                  Cancel
                </button>
              </div>
            </div>
          </div>

        </form>

      </div>
      <br />
      <hr style="border: 1px solid gray;">
      <div class="flex flex-row rounded-lg w-11/12" style="background-color:#5775a8; padding: 20px;">
        <span style="font-size: large; color: white;">
          Business Details
        </span>
      </div>
      <hr style="border: 1px solid gray;">
      <div class="flex flex-row rounded-lg w-11/12" style="border: 1px solid grey;">
        <table style="width: 100%;">
          <tr>
            <th style="border: 1px solid grey;">Business Name</th>
            <th style="border: 1px solid grey;">Address</th>
            <th style="border: 1px solid grey;">Address 2</th>
            <th style="border: 1px solid grey;">City</th>
            <th style="border: 1px solid grey;">Zip</th>
          </tr>
          <tr>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.businessName}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.address}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.address2}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.city}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.zip}}</td>
          </tr>
          <tr>
            <th style="border: 1px solid grey;">Type of Business</th>
            <th style="border: 1px solid grey;">Phone</th>
            <th style="border: 1px solid grey;">Extension</th>
            <th style="border: 1px solid grey;">County</th>
            <th style="border: 1px solid grey;">Status</th>
          </tr>
          <tr>
            <td style="border: 1px solid grey;text-align: center;">
              {{getTypeOfBusiness(currentComplaint.initialComplaint.typeOfBusiness)}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.businessPhone}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.businessPhoneExtension}}</td>
            <td style="border: 1px solid grey;text-align: center;">
              {{getCounty(currentComplaint.initialComplaint.county)}}</td>
            <td style="border: 1px solid grey;text-align: center;">{{currentComplaint.complaintStatus}}</td>
          </tr>
        </table>
      </div>
      <div class="flex flex-row rounded-lg w-11/12">
        <app-additionalComplaints class="flex flex-row w-full" [businessId]="businessId"></app-additionalComplaints>
      </div>

    </div>

  </mat-card-content>
</mat-card>